import React from "react";

export function PublicJobsListPreview({ customStyle }: { customStyle: any }) {
  const mainColor = customStyle?.mainColor || '#2563eb';
  const bgColor = customStyle?.bgColor || '#f9fafb';
  const textColor = customStyle?.textColor || '#222222';
  const logoUrl = customStyle?.logoUrl;
  const pageStyle = customStyle?.pageStyle || 'rounded';
  const borderRadius = pageStyle === 'square' ? '0' : '1rem'; // 1rem = rounded-sm
  const title = customStyle?.title || 'Acme Corp Job Openings';
  const headline = customStyle?.headline || 'Discover your next career opportunity';
  const jobs = [
    {
      job_id: '1',
      title: 'Frontend Developer',
      location: 'Remote',
      created_at: '2024-06-01',
      jobdesc_public: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur lacinia nisl eget sapien interdum pretium.'
    },
    {
      job_id: '2',
      title: 'Backend Engineer',
      location: 'Brussels',
      created_at: '2024-05-15',
      jobdesc_public: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur lacinia nisl eget sapien interdum pretium.'
    }
  ];
  return (
    <div style={{ background: bgColor, color: textColor, minHeight: 400, borderRadius: pageStyle === 'square' ? '0' : '0.75rem' }} className="shadow p-6">
      <div className="text-center mb-8">
        {logoUrl && <img src={logoUrl} alt="Logo" className="mx-auto mb-6" style={{ maxHeight: 80, width: 'auto', maxWidth: '100%' }} />}
        <h1 className="text-3xl font-bold mb-2" style={{ color: textColor }}>{title}</h1>
        <div className="text-lg mb-8" style={{ color: textColor }}>{headline}</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {jobs.map(job => (
          <div key={job.job_id} className="bg-white shadow p-4 border border-gray-100" style={{ borderRadius: pageStyle === 'square' ? '0' : '0.75rem' }}>
            <h2 className="text-xl font-bold text-gray-900 mb-2">{job.title}</h2>
            <div className="text-sm text-gray-600 mb-2">{job.location} • {job.created_at}</div>
            <div className="text-gray-700 text-sm">{job.jobdesc_public}</div>
            <button className="mt-4 px-4 py-2 bg-blue-500 text-white font-semibold" style={{ background: mainColor, borderRadius: pageStyle === 'square' ? '0' : '0.375rem' }}>View Details</button>
          </div>
        ))}
      </div>
    </div>
  );
} 